
import React, { useEffect, useRef, useState } from "react";
import Space from "../ui/Space";
import Label from "../ui/Label";
import Input from "../ui/Input";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import { getSaved, kbdEvent, save } from "../utils/Utils";
import Spin from "../ui/Spin";
import Float from "../ui/Float";
import Button from "../ui/Button";
export default function ReportsInventorySearch(props) {

    const { controller = "", route = "", callback = () => { }, setGoto = () => { } } = props;

    const keywordRef = useRef(null);
    const rowRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [keyword, setKeyword] = useState(false);
    const [focused, setFocused] = useState(false);

    const search = () => {

        let _search = "";
    
        if (focused) {
            _search = rowRef?.current?.value || "";
            let _int = Number.parseInt(_search) || -1;
            console.log(_int)
            if (_int < 0) {
                showError({error : "Must be a number"})
                return;
            }

            setGoto(_int);
            callback(false);
        } else {
            callback(keyword)
        }


    }

    useEffect(() => {


        if (focused) {
            rowRef.current.focus();
            //rowRef.current.select();
        } else {
            //keywordRef.current.select();
            keywordRef.current.focus()
        }
    }, [focused])




    // Keyboard Events
    useEffect(() => {
        if (loading) {
            return;
        }
        const actions = [
            { key: KBD.ESCAPE, action: (e) => { props.callback(false) } },
            { key: KBD.ENTER, action: (e) => { search() } },
            { key: KBD.TAB, action: (e) => { setFocused(!focused) } },
            { key: KBD.SHIFT_TAB, action: (e) => { setFocused(!focused) } },
            { key: KBD.ARROW_DOWN, action: (e) => { setFocused(!focused) } },
            { key: KBD.ARROW_UP, action: (e) => { setFocused(!focused) } },
            {
                key: KBD.F2, action: (e) => {

                    if (keyword) {
                        const _search = getSaved("search");
                        save("search", { ..._search, "keywords": keyword });
                    }
                    save("search_index", 0);

                    setTimeout(() => {
                        kbdEvent(KBD.F2)
                    }, 100)
                    callback()
                }
            },
            { key: KBD.PAGE_DOWN, action: (e) => { search(); } },
        ];
        const cleanup = listen(controller, route, actions, false, [KBD.ESCAPE, KBD.ENTER, KBD.PAGE_DOWN, KBD.F2, KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.TAB, KBD.SHIFT_TAB]);
        return cleanup;
    }, [loading, keyword, focused]);


    useEffect(() => {
        keywordRef.current?.focus();
    }, []);


    // Draw
    return (
        <Spin style={{ "margin": "0px -10px" }} loading={loading}>

            <div style={{ "width": "665px", "padding": "0px 10px" }}>
                <div className="shim" /><div className="shim" /><div className="shim" /><div className="shim" />
                <Space height={25} size={10}>
                    <Label className={"selected"} width={80}>Keywords</Label>
                    <Input ref={keywordRef} edit search placeholder="Search by partial title, author, ISBN, inventory notes, tags, publisher, etc" autoselect onChange={(e) => setKeyword(e)} onFocus={() => setFocused(false)}  onClick={() => setFocused(false)} width={560} onSearch={() => kbdEvent(KBD.ENTER)} uppercase controlled value={(keyword) ? keyword : ""} />
                </Space>
                <div className="shim" />
                <Space height={25} size={10}>
                    <Label className={"selected"} width={80}>Goto row #</Label>
                    <Input ref={rowRef}  onClick={() => setFocused(true)}  onFocus={() => setFocused(true)} edit number search width={120} placeholder="Set row number" autoselect />
                </Space>

                <div className="shim" /><div className="shim" /><div className="shim" /><div className="shim" /><div className="shim" /><div className="shim" />
                <div style={{ "backgroundColor": "var(--console-bg)", "margin": "-10px -10px", "borderTop": "2px solid var(--border-secondary)", "padding": "10px" }}>
                    <Float>
                        <div style={{ "padding": "0px 10px" }}>
                            <em><small style={{ "fontSize": "13px" }}>Tip: Press F2 to search your entire inventory.</small></em>
                        </div>
                        <div style={{ "padding": "0px 10px" }}>
                            <Button style={{ "width": "100px" }} onClick={() => kbdEvent(KBD.ENTER)} styled>Search</Button>
                        </div>
                    </Float>
                </div>
            </div>
        </Spin>
    )
}